import { MapPin, Phone, Mail, Instagram } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer style={{ background: "var(--bg-warm)" }}>
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <p className="eyebrow mb-3" style={{ color: "var(--accent)" }}>
            <MapPin size={14} strokeWidth={1.5} className="inline mr-2" /> Visit Us
          </p>
          <p className="leading-relaxed text-sm" style={{ color: "var(--ink)" }}>
            Cocoamaya Patisserie<br/>
            Ground Floor, Silver Monument<br/>
            Sakinaka Junction, 90 Feet Road<br/>
            Sakinaka, Mumbai
          </p>
        </div>

        <div>
          <p className="eyebrow mb-3" style={{ color: "var(--accent)" }}>
            <Phone size={14} strokeWidth={1.5} className="inline mr-2" /> Call / WhatsApp
          </p>
          <p className="leading-relaxed text-sm" style={{ color: "var(--ink)" }}>
            +91 98193 00124<br/>
            <span style={{ color: "var(--ink-soft)" }}>Everyday: 9 AM – 9 PM</span>
          </p>
        </div>

        <div>
          <p className="eyebrow mb-3" style={{ color: "var(--accent)" }}>
            <Mail size={14} strokeWidth={1.5} className="inline mr-2" /> Email Us
          </p>
          <p className="leading-relaxed text-sm" style={{ color: "var(--ink)" }}>
            <a href="mailto:hello@cocoamayapatisserie.com" className="hover:underline" style={{ color: "var(--ink)" }} data-testid="footer-email">
              hello@cocoamayapatisserie.com
            </a><br/>
            <span style={{ color: "var(--ink-soft)" }}>We'll reply within 24h</span>
          </p>
        </div>

        <div>
          <p className="eyebrow mb-3" style={{ color: "var(--accent)" }}>
            <Instagram size={14} strokeWidth={1.5} className="inline mr-2" /> Follow Us
          </p>
          <p className="leading-relaxed text-sm" style={{ color: "var(--ink)" }}>
            @cocoamayapatisserie<br/>
            <span style={{ color: "var(--ink-soft)" }}>Instagram</span>
          </p>
        </div>
      </div>

      <div className="border-t" style={{ borderColor: "rgba(45,61,38,0.15)" }}>
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-5 text-xs flex flex-wrap justify-between gap-3" style={{ color: "var(--ink-soft)" }}>
          <span>© 2026 Cocoamaya Patisserie. All rights reserved.</span>
          <span className="flex flex-wrap gap-x-5 gap-y-2">
            <Link to="/privacy" data-testid="footer-privacy-link">Privacy Policy</Link>
            <Link to="/terms" data-testid="footer-terms-link">Terms &amp; Conditions</Link>
            <Link to="/refund" data-testid="footer-refund-link">Refund Policy</Link>
            <Link to="/return" data-testid="footer-return-link">Return Policy</Link>
            <Link to="/shipping" data-testid="footer-shipping-link">Shipping Policy</Link>
          </span>
        </div>
      </div>
    </footer>
  );
};
